import React from "react";

import { useMap } from "react-map-gl";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
	layerDefFillColorSelector,
} from "../../recoil";

import { loacLayerAtom } from './atoms'
import LoacLayerSelector from './LoacLayerSelector'
import LoacLegend from './LoacLegend'

export default function LoacControls() {
	const mapRef = useMap()
	const loacLayer = useRecoilValue(loacLayerAtom)
	const setLayerFillColor = useSetRecoilState(
		layerDefFillColorSelector('loac')
	)

	React.useEffect(() => {
		const map = mapRef.map
		
		if (!map) {
			return
		}

		setLayerFillColor(loacLayer.fillColor)
	}, [loacLayer])

	return (
		<>
			<LoacLayerSelector />
			<LoacLegend />
		</>
	)
}